import _ from 'lodash';
import keyMirror from 'keymirror';

// Controls new transfers in the customer UI; existing payment records retain their status.
export const BANK_TRANSFER_UI_ENABLED = false;

const CONSTANTS = {
	STATUS: {
		INITIAL: 'initial',
		BUSY: 'busy',
		SUCCESS: 'success',
		FAILED: 'failed',
	},
	// Mirrors the `error_code` on the 409s of `POST /bank_transfer/create` (services/api/routes/private/bank_transfer.js).
	ERROR_CODES: {
		OPEN_BANK_TRANSFER_REQUEST: 'OPEN_BANK_TRANSFER_REQUEST',
		PAYMENT_ALREADY_ON_REQUEST: 'PAYMENT_ALREADY_ON_REQUEST',
	},
};

// Define action constants
export default _.extend(
	{},
	CONSTANTS,
	keyMirror({
		BANK_TRANSFER_FAILED: null,
		BANK_TRANSFER_SUCCESS: null,
		BANK_TRANSFER_LOADING: null,
		BANK_TRANSFER_PROGRESS: null,
		BANK_TRANSFER_RESET: null,
	}),
);
